import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function CTASection() {
  const handleDownload = () => {
    window.location.href = 'https://www.mjebook.com/cart/43032191631478:1';
  };
  return <Section id="cta" background="teal" className="text-center" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <h2 className="text-4xl md:text-5xl font-bold text-[#1F2937] mb-6" data-id="element-32">
          La promesa real
        </h2>
        <p className="text-xl text-[#4B5563] mb-12 leading-relaxed font-normal" data-id="element-33">
          No te prometo perfección. Te prometo algo mejor: un sistema que te
          saca del caos y te devuelve consistencia… aunque tengas semanas
          difíciles.
        </p>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl max-w-2xl mx-auto" data-id="element-34">
          <h3 className="text-2xl md:text-3xl font-bold text-[#1F2937] mb-4" data-id="element-35">
            Meal Prep para Cerebro Saturado
          </h3>
          <p className="text-[#4B5563] mb-6 font-normal" data-id="element-36">
            Método 3–3–7: El sistema anti-caos para comer bien.
          </p>

          <div className="mb-8 p-6 bg-[#EFF6FF] rounded-lg border-2 border-[#1e3a8a] relative overflow-hidden" data-id="element-37">
            <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-38">
              68% OFF
            </div>
            <p className="text-sm text-[#4B5563] mb-2" data-id="element-39">
              Precio especial de lanzamiento
            </p>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-40">
              <p className="text-2xl font-medium text-[#6B7280] line-through" data-id="element-41">
                $19.99
              </p>
              <p className="text-5xl font-bold text-[#1e3a8a]" data-id="element-42">$6.39</p>
            </div>
            <p className="text-sm text-green-600 font-semibold mt-2" data-id="element-43">
              ¡Ahorras $13.60!
            </p>
            <p className="text-xs text-[#6B7280] mt-2" data-id="element-44">
              Oferta por tiempo limitado
            </p>
          </div>

          <div className="flex flex-col items-center space-y-4" data-id="element-45">
            <Button fullWidth className="text-lg py-6 shadow-xl shadow-[#1e3a8a]/20" onClick={handleDownload} data-id="element-46">
              Descárgalo Aquí
            </Button>
            <p className="text-xs text-[#6B7280] mt-4 font-normal" data-id="element-47">
              Pago seguro • Descarga inmediata • Acceso de por vida
            </p>
          </div>
        </div>

        <p className="mt-12 text-[#4B5563] text-sm font-normal" data-id="element-48">
          Si quieres que comer deje de ser otra batalla mental, este ebook es
          para ti.
        </p>
      </div>
    </Section>;
}